import React from "react";
import PropTypes from "prop-types";
import Footer from "../../layouts/footer";
import Header from "../../layouts/header";
import Layout from "../../layouts/index";
import JobDetailsContainer from "../../containers/career/jo-details";
import JobData from "../../data/jobs.json";
import ScrollToTop from "../../components/scroll-to-top";
import SEO from "../../components/seo";

const JobDetailsPage = ({
    match: {
        params: { id },
    },
}) => {
    const jobTitle = id;
    const data = JobData[1].jobDetails.filter(
        (jobItem) => jobItem.path === jobTitle
    );

    return (
        <React.Fragment>
            <Layout>
                <SEO
                    title={
                        data[0]["title"] +
                        " - Job | NeoGrowth - Lending simplified. Growth amplified."
                    }
                />
                <div className="wrapper">
                    <Header />
                    {/* <PageBanner
                        title="Blog Details"
                        excerpt="Pleasure rationally encounter consequences <br />
                        are extremely painful great oppurtunity"
                        image="/images/blog/banner.png"
                    /> */}
                    <JobDetailsContainer
                        data={data[0]}
                        classOption="section-pt"
                    />

                    <Footer />
                    <ScrollToTop />
                </div>
            </Layout>
        </React.Fragment>
    );
};

JobDetailsPage.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        }),
    }),
};

export default JobDetailsPage;
